const userLogin = {
  state:{
    show: false
  },
  mutations: {
    SHOW_FUN: (state, data) => {
      state.show = data
    },
  },
  actions: {
    set_user_login: ({ commit }, data) => {
      commit('SHOW_FUN', data)
    },
  }
}

export default userLogin



// WEBPACK FOOTER //
// ./src/store/modules/userLogin.js